import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useEffect } from "react";
import Home from './pages/Home';
import About from './pages/About';
import Login from './pages/Login';
import FacultyPage from './pages/Faculty';
import AbhaySardesai from './profiles/AbhaySardesai';
import SeasonOne from './pages/SeasonOne';
import SeasonTwo from './pages/SeasonTwo';
import ProfileLandingPage from './users/userProfilePage';
import EditProfilePage from './users/editProfilePage';
import MembershipPlan from './users/membershipPlan';
import SeasonOneEpisodes from './pages/SeasonOneEpisodes';
import SeasonTwoEpisodes from './pages/SeasonTwoEpisodes';
import DadibaPundole from './profiles/DadibaPundole';
import SandhyaBordewekar from './profiles/SandhyaBordewekar';
import TasneemZakariaMehta from './profiles/TasneemZakariaMehta';
import YashodharaDalmia from './profiles/YashodharaDalmia';
import ZehraJumabhoy from './profiles/ZehraJumabhoy';
import JitishKallat from './profiles/JitishKallat';
import KamayaniSharma from './profiles/KamayaniSharma';
import MeeraMenezes from './profiles/MeeraMenezes';
import UrshilaMehta from './profiles/UrshilaMehta';
import ShwetaUpadhyay from './profiles/ShwetaUpadhyay';
import RupeshPandey from './profiles/RupeshPandey';
import YvetteBaptista from './profiles/YvetteBaptista';
import Error404 from './pages/Error404';



function App() {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.reload();
    }, 4 * 60 * 60 * 1000); // 4 hours

    return () => clearTimeout(timer);
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/season-one" element={<SeasonOne />} />
        <Route path="/season-two" element={<SeasonTwo />} />
        <Route path="/faculty" element={<FacultyPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/profile" element={<ProfileLandingPage />} />
        <Route path="/profile/edit" element={<EditProfilePage />} />
        <Route path="/membership-plan" element={<MembershipPlan />} />
        <Route path="/season-one-episodes" element={<SeasonOneEpisodes />} />
        <Route path="/season-two-episodes" element={<SeasonTwoEpisodes />} />
        <Route path="/teams/abhay-sardesai" element={<AbhaySardesai />} />
        <Route path="/teams/dadiba-pundole" element={<DadibaPundole />} />
        <Route path="/teams/sandhya-bordewekar" element={< SandhyaBordewekar />} />
        <Route path="/teams/tasneem-zakaria-mehta" element={< TasneemZakariaMehta />} />
        <Route path="/teams/yashodhara-dalmia" element={< YashodharaDalmia />} />
        <Route path="/teams/zehra-jumabhoy" element={< ZehraJumabhoy />} />
        <Route path="/teams/jitish-kallat" element={< JitishKallat />} />
        <Route path="/teams/kamayani-sharma" element={<KamayaniSharma />} />
        <Route path="/teams/meera-menezes" element={<MeeraMenezes />} />
        <Route path="/teams/urshila-mehta" element={<UrshilaMehta />} />
        <Route path="/teams/shweta-upadhyay" element={<ShwetaUpadhyay />} />
        <Route path="/teams/rupesh-pandey" element={<RupeshPandey />} />
        <Route path="/teams/yvette-baptista" element={<YvetteBaptista />} />
        {/* 404 catch-all */}
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Router>
  );
}

export default App;
